module.exports = __webpack_public_path__ + "static/media/accentStyle.fd08057a.gif";